import { render, staticRenderFns } from "./EditModalDocumentLoadingError.vue?vue&type=template&id=12a41b70&"
import script from "./EditModalDocumentLoadingError.vue?vue&type=script&lang=js&"
export * from "./EditModalDocumentLoadingError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports